var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3191_111242)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.3311,
    cy: 20,
    r: 18,
    fill: "#EEF2FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0999 29.3478L25.6521 28.6576C26.1373 28.0511 27.1677 28.1 27.5776 28.7488C28.0706 29.5295 29.2884 29.3743 29.6261 28.6562C29.6437 28.6189 29.5997 28.7123 29.6373 28.3892C29.6748 28.0661 29.6592 27.9923 29.6279 27.8448L27.7048 18.7641C27.2215 16.482 26.9798 15.3409 26.1485 14.6704C25.3173 14 24.144 14 21.7976 14H19.5208C17.1744 14 16.0011 14 15.1698 14.6704C14.3386 15.3409 14.0969 16.482 13.6136 18.7641L11.6905 27.8448C11.6592 27.9923 11.6436 28.0661 11.6811 28.3892C11.7186 28.7123 11.6747 28.6189 11.6923 28.6562C12.03 29.3743 13.2477 29.5295 13.7408 28.7488C14.1507 28.1 15.1811 28.0511 15.6663 28.6576L16.2185 29.3478C16.9143 30.2174 18.3674 30.2174 19.0632 29.3478L19.15 29.2392C19.8883 28.3165 21.4301 28.3165 22.1684 29.2392L22.2552 29.3478C22.951 30.2174 24.4041 30.2174 25.0999 29.3478Z",
    stroke: "#2C5290",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1425 17.5C10.5572 16.892 10.6674 16.1089 10.6674 14.1518C10.6674 12.1946 10.6674 11.216 11.2527 10.608C11.838 10 12.7801 10 14.6642 10H26.6544C28.5384 10 29.4805 10 30.0658 10.608C30.6511 11.216 30.6511 12.1946 30.6511 14.1518C30.6511 16.1089 30.7606 16.892 30.1753 17.5",
    stroke: "#2C5290",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6592 18H17.6592",
    stroke: "#2C5290",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6592 22H16.6592",
    stroke: "#2C5290",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3191_111242",
    x: 0.331055,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3191_111242"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.726419 0 0 0 0 0.803805 0 0 0 0 0.930941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3191_111242"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3191_111242",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetpay);
export default __webpack_public_path__ + "static/media/netpay.97385135.svg";
export { ForwardRef as ReactComponent };